import React from "react";
export const HomeOneIcon = () => {
  return (
    <svg
      width="100%"
      height="auto"
      viewBox="0 0 121 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="60.9004" cy="60" r="60" fill="var(--primary-color)" />
      <circle
        cx="60.9004"
        cy="60"
        r="51"
        fill="var(--primary-color)"
        stroke="white"
        stroke-width="2"
      />
      <path
        d="M43.8007 79.9938C43.8007 80.4354 44.1591 80.7938 44.6007 80.7938H56.5975V71.1938H66.1975V80.7938H78.1943C78.4064 80.7938 78.6099 80.7095 78.7599 80.5595C78.91 80.4095 78.9943 80.206 78.9943 79.9938V61.5938H43.8007V79.9938ZM81.9767 57.0498L78.9943 54.4258V42.4002C78.9943 41.5515 78.6571 40.7376 78.057 40.1375C77.4569 39.5373 76.6429 39.2002 75.7943 39.2002C74.9456 39.2002 74.1316 39.5373 73.5315 40.1375C72.9314 40.7376 72.5943 41.5515 72.5943 42.4002V48.8002L61.9799 39.4882C61.8346 39.3339 61.6341 39.2436 61.4223 39.237C61.2106 39.2304 61.0048 39.3081 60.8503 39.453L60.8151 39.4882L40.8151 56.9698C40.7098 57.0833 40.6397 57.2248 40.6133 57.3773C40.5869 57.5298 40.6053 57.6867 40.6662 57.829C40.7272 57.9713 40.8281 58.0928 40.9568 58.1788C41.0854 58.2649 41.2363 58.3118 41.3911 58.3138L47.0007 58.4002H81.3911C81.5473 58.4006 81.7002 58.3552 81.8309 58.2698C81.9616 58.1843 82.0645 58.0624 82.1268 57.9191C82.189 57.7759 82.208 57.6175 82.1813 57.4636C82.1547 57.3097 82.0835 57.1637 81.9767 57.0498Z"
        fill="white"
      />
    </svg>
  );
};
export const HomeTwoIcon = () => {
  return (
    <svg
      width="100%"
      height="auto"
      viewBox="0 0 121 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="60.7998" cy="60" r="60" fill="var(--primary-color)" />
      <circle
        cx="60.7998"
        cy="60"
        r="51"
        fill="var(--primary-color)"
        stroke="white"
        stroke-width="2"
      />
      <path
        d="M61.8207 45.4951C61.6811 45.3616 61.4954 45.2871 61.3022 45.2871C61.1091 45.2871 60.9234 45.3616 60.7838 45.4951L43.5244 61.983C43.4511 62.0531 43.3928 62.1373 43.353 62.2306C43.3132 62.3239 43.2927 62.4243 43.2929 62.5258L43.29 78.0001C43.29 78.7958 43.6061 79.5589 44.1687 80.1215C44.7313 80.6841 45.4944 81.0001 46.29 81.0001H55.2994C55.6972 81.0001 56.0788 80.8421 56.3601 80.5608C56.6414 80.2795 56.7994 79.898 56.7994 79.5001V66.7501C56.7994 66.5512 56.8784 66.3605 57.0191 66.2198C57.1597 66.0792 57.3505 66.0001 57.5494 66.0001H65.0494C65.2483 66.0001 65.4391 66.0792 65.5797 66.2198C65.7204 66.3605 65.7994 66.5512 65.7994 66.7501V79.5001C65.7994 79.898 65.9574 80.2795 66.2388 80.5608C66.5201 80.8421 66.9016 81.0001 67.2994 81.0001H76.305C77.1007 81.0001 77.8638 80.6841 78.4264 80.1215C78.989 79.5589 79.305 78.7958 79.305 78.0001V62.5258C79.3052 62.4243 79.2847 62.3239 79.2449 62.2306C79.2051 62.1373 79.1468 62.0531 79.0735 61.983L61.8207 45.4951Z"
        fill="white"
      />
      <path
        d="M83.3227 58.8891L76.3102 52.1803V42C76.3102 41.6022 76.1521 41.2206 75.8708 40.9393C75.5895 40.658 75.208 40.5 74.8102 40.5H70.3102C69.9123 40.5 69.5308 40.658 69.2495 40.9393C68.9682 41.2206 68.8102 41.6022 68.8102 42V45L63.3802 39.8081C62.872 39.2944 62.1164 39 61.2998 39C60.4861 39 59.7323 39.2944 59.2242 39.8091L39.2836 58.8872C38.7005 59.4497 38.6273 60.375 39.158 60.9844C39.2912 61.1382 39.4544 61.2633 39.6375 61.352C39.8206 61.4408 40.0199 61.4914 40.2232 61.5007C40.4265 61.51 40.6295 61.4778 40.82 61.4061C41.0105 61.3344 41.1844 61.2248 41.3311 61.0837L60.7842 42.495C60.9238 42.3615 61.1095 42.287 61.3027 42.287C61.4958 42.287 61.6815 42.3615 61.8211 42.495L81.2761 61.0837C81.5627 61.3586 81.9465 61.5086 82.3435 61.5008C82.7405 61.4931 83.1182 61.3283 83.3939 61.0425C83.9695 60.4462 83.9217 59.4619 83.3227 58.8891Z"
        fill="white"
      />
    </svg>
  );
};

export const HomeThreeIcon = () => {
  return (
    <svg
      width="100%"
      height="auto"
      viewBox="0 0 121 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="60.8997" cy="60" r="60" fill="var(--primary-color)" />
      <circle
        cx="60.8997"
        cy="60"
        r="51"
        fill="var(--primary-color)"
        stroke="white"
        stroke-width="2"
      />
      <path
        d="M74.3997 42H69.3997C69.1344 42 68.8801 42.1054 68.6926 42.2929C68.505 42.4804 68.3997 42.7348 68.3997 43V43.118L75.3997 48.718V43C75.3997 42.7348 75.2943 42.4804 75.1068 42.2929C74.9192 42.1054 74.6649 42 74.3997 42Z"
        fill="white"
      />
      <path
        d="M58.8997 55C58.8997 54.337 59.1631 53.7011 59.6319 53.2322C60.1007 52.7634 60.7366 52.5 61.3997 52.5C62.0627 52.5 62.6986 52.7634 63.1674 53.2322C63.6363 53.7011 63.8997 54.337 63.8997 55C63.8997 55.663 63.6363 56.2989 63.1674 56.7678C62.6986 57.2366 62.0627 57.5 61.3997 57.5C60.7366 57.5 60.1007 57.2366 59.6319 56.7678C59.1631 56.2989 58.8997 55.663 58.8997 55Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M78.8997 57.92L80.4637 59.172C80.775 59.4146 81.1694 59.5247 81.5615 59.4785C81.9535 59.4322 82.3114 59.2333 82.5578 58.9249C82.8041 58.6164 82.9189 58.2233 82.8773 57.8308C82.8358 57.4383 82.6411 57.0779 82.3357 56.828L66.0857 43.828C64.7557 42.7637 63.103 42.1838 61.3997 42.1838C59.6963 42.1838 58.0436 42.7637 56.7137 43.828L40.4637 56.828C40.1528 57.0765 39.9534 57.4383 39.9094 57.8338C39.8653 58.2293 39.9802 58.6261 40.2287 58.937C40.4772 59.2478 40.839 59.4472 41.2345 59.4912C41.63 59.5353 42.0268 59.4205 42.3377 59.172L43.8997 57.92V78.5H41.3997C41.0018 78.5 40.6203 78.658 40.339 78.9393C40.0577 79.2206 39.8997 79.6021 39.8997 80C39.8997 80.3978 40.0577 80.7793 40.339 81.0606C40.6203 81.3419 41.0018 81.5 41.3997 81.5H81.3997C81.7975 81.5 82.179 81.3419 82.4603 81.0606C82.7416 80.7793 82.8997 80.3978 82.8997 80C82.8997 79.6021 82.7416 79.2206 82.4603 78.9393C82.179 78.658 81.7975 78.5 81.3997 78.5H78.8997V57.92ZM55.8997 55C55.8997 53.5413 56.4791 52.1423 57.5106 51.1109C58.542 50.0794 59.941 49.5 61.3997 49.5C62.8583 49.5 64.2573 50.0794 65.2887 51.1109C66.3202 52.1423 66.8997 53.5413 66.8997 55C66.8997 56.4586 66.3202 57.8576 65.2887 58.889C64.2573 59.9205 62.8583 60.5 61.3997 60.5C59.941 60.5 58.542 59.9205 57.5106 58.889C56.4791 57.8576 55.8997 56.4586 55.8997 55ZM61.4997 62.5C62.8277 62.5 63.9737 62.5 64.8917 62.624C65.8757 62.756 66.8177 63.054 67.5817 63.818C68.3457 64.582 68.6437 65.524 68.7757 66.508C68.8917 67.368 68.8997 68.428 68.8997 69.654V78.5H65.8997V70C65.8997 68.544 65.8957 67.6 65.8037 66.908C65.7157 66.258 65.5757 66.054 65.4597 65.94C65.3437 65.826 65.1417 65.684 64.4917 65.596C63.7977 65.504 62.8557 65.5 61.3997 65.5C59.9437 65.5 58.9997 65.504 58.3077 65.596C57.6577 65.684 57.4537 65.826 57.3397 65.94C57.2257 66.054 57.0837 66.258 56.9957 66.908C56.9037 67.602 56.8997 68.544 56.8997 70V78.5H53.8997V69.9C53.8997 68.572 53.8997 67.426 54.0237 66.508C54.1557 65.524 54.4537 64.582 55.2177 63.818C55.9817 63.054 56.9257 62.756 57.9077 62.624C58.8257 62.5 59.9717 62.5 61.3017 62.5H61.4997Z"
        fill="white"
      />
      <path
        d="M58.8997 55C58.8997 54.337 59.1631 53.7011 59.6319 53.2322C60.1007 52.7634 60.7366 52.5 61.3997 52.5C62.0627 52.5 62.6986 52.7634 63.1674 53.2322C63.6363 53.7011 63.8997 54.337 63.8997 55C63.8997 55.663 63.6363 56.2989 63.1674 56.7678C62.6986 57.2366 62.0627 57.5 61.3997 57.5C60.7366 57.5 60.1007 57.2366 59.6319 56.7678C59.1631 56.2989 58.8997 55.663 58.8997 55Z"
        fill="white"
      />
    </svg>
  );
};
